import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import fr from '../data/translations/fr.js';
import nl from '../data/translations/nl.js';

export const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr: fr,
    nl: nl,
  }
});


// WEBPACK FOOTER //
// ./src/tools/i18n.js